import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getBulkUpdateItemsModel = createSelector(
    getModel,
    (model) => model.bulkUpdateItems,
);

export const getIsFetchingBulk = createSelector(
    getBulkUpdateItemsModel,
    (model) => model.isFetching,
);

export const getDuplicateModel = createSelector(
    getModel,
    (model) => model.duplicateTemplate,
);

export const getIsDuplicatingTemplate = createSelector(
    getDuplicateModel,
    (model) => model.isDuplicating,
);

export const getFilterData = createSelector(
    getModel,
    (model) => model.filterData,
);

export const getTemplatesModel = createSelector(
    getModel,
    (model) => model.filterTemplates,
);

export const getTemplatesData = createSelector(
    getTemplatesModel,
    (model) => model.data.data,
);

export const getTemplatesErrors = createSelector(
    getTemplatesModel,
    (model) => model.errors,
);

export const getIsFetchingTemplates = createSelector(
    getTemplatesModel,
    (model) => model.isFetching,
);

export const getTemplatesPagination = createSelector(
    getTemplatesModel,
    (model) => model.data.pagination || {},
);

export const getSave = createSelector(getModel, (model) => model.save);

export const getIsSaving = createSelector(getSave, (save) => save.isSaving);

export const getDataSave = createSelector(getSave, (save) => save.data);

export const getErrorsSave = createSelector(getSave, (save) => save.errors);
